module.exports = __webpack_public_path__ + "media/images/Path-bd3916d1.png";